import { PaginatedData } from '../types/pagination.types';

export const DEFAULT_PAGINATED_TABLE_DATA: PaginatedData<any> = {
  docs: [],
  totalDocs: 0,
  limit: 10,
  totalPages: 0,
  page: 1,
  pagingCounter: 0,
  hasPrevPage: false,
  hasNextPage: false,
  prevPage: null,
  nextPage: null,
};

export const DEFAULT_PAGINATION_PAGE = 1;
export const DEFAULT_PAGINATION_LIMIT = 10;
export const DEFAULT_LIST_ALL_PAGINATION_LIMIT = 1000;
